import "../styles/components/Loader.scss";

import React from "react";

function Loader() {
  return (
    <div>
      <div className="Loader">
        <div className="loader"></div>
      </div>
    </div>
  );
}

export default Loader;
